import React from 'react'

import cn from '../../../../commons/src/libs/class-names'
import {
  countChildrenWithFragments,
  mapChildrenWithFragments,
} from '../../../../commons/src/services/react-children'
import {getCellLayout} from './utils'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

import TableCell from './TableCell'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    computedWidth?: string
    align?: 'left' | 'center' | 'right'
    firstCell?: boolean
    lastCell?: boolean
    children?: React.ReactNode
  }
>

const TableCellGroup = ({
  className,
  children,
  computedWidth: width,
  align = 'left',
  firstCell = false,
  lastCell = false,
  ...props
}: Props) => {
  const {computedWidths} = getCellLayout(children)
  const childCount = countChildrenWithFragments(children)

  return (
    <div
      {...props}
      className={cn(
        'TableCellGroup',
        {fixed: !!width && width.includes('px'), firstCell, lastCell},
        className
      )}
      style={{width}}
    >
      {mapChildrenWithFragments<React.ComponentProps<typeof TableCell>>(children, (child, i) =>
        React.cloneElement(child, {
          computedWidth: computedWidths[i],
          align: child.props.align || align,
          firstCell: i === 0 && firstCell,
          lastCell: i === childCount - 1 && lastCell,
        })
      )}
    </div>
  )
}

export default TableCellGroup
